// extracted by mini-css-extract-plugin
export default {"gradientCodeLineHeight":"25px","smallBreakPoint":"750px"};